import { render } from "./EditAccessory.vue?vue&type=template&id=e10c47ec"
import script from "./EditAccessory.vue?vue&type=script&lang=js"
export * from "./EditAccessory.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__